export default "__VITE_ASSET__C$UI4JHo__"